import DefaultMonitoring from "src/components/feature/Monitoring";

const Monitoring = () => {
  return <DefaultMonitoring />;
};

export default Monitoring;
